import { Http } from '@/lib/http';
import { URL_PATHS } from './constants';

export class InsuranceManagementService extends Http {
  constructor() {
    super();
    this.endPoint = '/loan-pro/app/loan-services/manage-loans';
  }

  getInsurancePolicies(page, limit, order = 'asc', sort = 'id', search) {
    let queryString = [];
    if (page) {
      queryString.push(`page=${page}`);
    }
    if (limit) {
      queryString.push(`limit=${limit}`);
    }
    if (search) {
      queryString.push(`searchParam=${search}`);
    }
    queryString.push(`order=${order}`);
    queryString.push(`sort=${sort}`);
    return this.httpClient().get(
      `${this.endPoint}/insurances?${queryString.join('&')}`
    );
  }

  createInsurancePolicy(policy) {
    return this.httpClient().post(`${this.endPoint}/insurances`, policy);
  }

  updateInsurancePolicy(id, updates) {
    return this.httpClient().patch(
      `${this.endPoint}/insurances/${id}`,
      updates
    );
  }

  deleteInsurancePolicy(id) {
    return this.httpClient().delete(`${this.endPoint}/insurances/${id}`);
  }

  /**
   * Search for pledged or insurance to be pledged
   * @param payload - The `payload` parameter is used to filter the insurance
   * @example
   * const payload = {
   *   loanId: string - Loan id
   *   accountNumber?: string - the account number to which the policy belongs
   *   policyNumber?: string - the policy number for the insurance
   *   search?: string - a search string containing trn or name of collateral owner 
   * }
   * @returns {
   *   data: Array<Object> - insurances
   *   total: number - total number of insurance for the given filter
   *}
   */
  findLoanInsurance(page = 1, limit = 25, payload) {
    return this.httpClient().post(
      `${URL_PATHS.LOANPRO_APP}/loans/insurances/search?page=${page}&limit=${limit}`,
      payload
    );
  }

  /**
   * Pledge an insured amount to a loan
   * @param loanId - The id of the loan the insurance is to be pledged to 
   * @param insuranceId - The id of the insurance 
   * @param payload - The `payload` parameter used to create the pledged amount record
   * @example
   * const payload = {
   *   loanId: string - Loan id
   *   insuranceId: string - insurance id policy
   *   pledgeAmount: number - amount pledged to loan
   * }
   * @returns Object - pledged insurance
   */
  pledgeInsuranceToLoan(loanId, insuranceId, payload) {
    return this.httpClient().patch(
      `${URL_PATHS.LOANPRO_APP}/loans/${loanId}/insurances/${insuranceId}`,
      payload
    );
  }
  
  /**
   * Remove pledged insurance from loan
   * @param loanId - The id of the loan to remove pledged insurance from
   * @param insuranceId - The id of the insurance policy to remove from loan.
   *
   * @returns Object - removed pledged insurance
   */
  removeInsuranceFromLoan(loanId, insuranceId) {
    return this.httpClient().delete(
      `${URL_PATHS.LOANPRO_APP}/loans/${loanId}/insurances/${insuranceId}`
    );
  }
}
